import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.scss";
import Home from "./pages/Home";
import Error404 from "./pages/Error404";
import Dashboard from "./pages/Dashboard";
import MobileOTP from "./pages/MobileOTP";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import 'react-loading-skeleton/dist/skeleton.css';
import 'mdbreact/dist/css/mdb.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import AllOrder from "./pages/order/AllOrder";
import CenterWiseReport from "./pages/report/CenterWiseReport";
import AgentWiseReport from "./pages/report/AgentWiseReport";
import CompanyWiseReport from "./pages/report/CompanyWiseReport";
import AgentPerformance from "./pages/report/AgentPerformance";
import DealerWiseReport from "./pages/report/DealerWiseReport";
import CourierWiseReport from "./pages/report/CourierWiseReport";
import CenterPerformance from "./pages/report/CenterPerformance";
import CenterHeadPerformance from "./pages/report/CenterHeadPerformance";
import SameProductReport from "./pages/report/SameProductReport";
import PPCPerformance from "./pages/report/PPCPerformance";
import ClusterHeadInOutPerformance from "./pages/report/ClusterHeadInOutPerformance";
import CenterHeadInOutPerformance from "./pages/report/CenterHeadInOutPerformance";
import OnlineMedia from "./pages/report/OnlineMedia";
import TopProductsByStateReport from "./pages/report/TopProductsByStateReport";
import TopProductsByClusterReport from "./pages/report/TopProductsByClusterReport";
import ProductPerformance from "./pages/report/ProductPerformance";


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mobile-otp" element={<MobileOTP />} />
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Orders */}
          <Route path="/all-orders" element={<AllOrder />} />

          {/* Reports */}
          <Route path="/center-wise-reports" element={<CenterWiseReport />} />
          <Route path="/agent-wise-reports" element={<AgentWiseReport />} />
          <Route path="/company-wise-reports" element={<CompanyWiseReport />} />
          <Route path="/agent-performance-report" element={<AgentPerformance />} />
          <Route path="/dealer-wise-report" element={<DealerWiseReport />} />
          <Route path="/courier-wise-report" element={<CourierWiseReport />} />
          <Route path="/center-performance-report" element={<CenterPerformance />} />
          <Route path="/center-head-performance-report/:slug" element={<CenterHeadPerformance />} />
          <Route path="/cluster-head-in-out-performance-report" element={<ClusterHeadInOutPerformance />} />
          <Route path="/center-head-in-out-performance-report/:slug" element={<CenterHeadInOutPerformance />} />
          <Route path="/same-product-with-agent-report" element={<SameProductReport />} />
          <Route path="/ppc-performance-report" element={<PPCPerformance />} />
          <Route path="/online-media-reports" element={<OnlineMedia />} />
          <Route path="/top-product-by-state" element={<TopProductsByStateReport />} />
          <Route path="/top-product-by-cluster-head" element={<TopProductsByClusterReport />} />
          <Route path="/product-performance-report" element={<ProductPerformance />} />
          {/* 404 */}
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>

      <ToastContainer position="bottom-center" />
    </>
  );
}

export default App;

